// extracted by mini-css-extract-plugin
export default {"input":"K8-z","button":"L8-z","selected":"M8-z","unavailable":"N8-z","oos":"O8-z","image":"P8-z","paperCutDisabledOverlay":"Q8-z"};